import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { Icon } from 'kangarootime-ui';

const NewButton = ({
  onClick,
  tooltip,
  ...props
}) => {
  return (
    <Tooltip title={tooltip} placement='top'>
      <div style={{ cursor: 'pointer' }} onClick={onClick}>
        <Icon icon='add-outline' color='#AB9BA9' height={24} width={24} />
      </div>
    </Tooltip>
  );
};

NewButton.propTypes = {
  onClick: PropTypes.func,
  tooltip: PropTypes.string
};

export default NewButton;
